'use strict';

class Page01 extends BaseComponent {
    constructor(element, state) {
        //init BaseComponent
        super(element, state);
        this.debug = false;

        //set template id
        this._view = $('#page01_Page01').html();
        //set template props
        this._props = {
			intro: _t('page01_intro'),
			outro: _t('page_01_outro')
        };
        this.state.pageNumber = 1;

        _.bindAll(this, 'onCreatedNewName', 'onReset');

        return this
    }

    init() {
        //gotoNextPage
        this.gotoNextPage = new GotoNextPage($('div.goto-next-page', this.$el), {urlNext: 'page02', pageNumber: this.state.pageNumber + 1}).render().init();

        this.$step = $('.step', this.$el);
        this.stepInput = new ListInput(null, {
            placeholder: _t('page01_input_placeholder'),
            btn_submit: _t('page01_input_submit'),
            sendInputFn: RemoteData.insertNewName
        }).render().init();
        this.stepOutput = new ListOutput(null, {
            btn_back: _t('page01_output_btn_back'),
            copy: _t('page01_output_copy'),
            updateListFn: RemoteData.getNameslist
        }).render().init();

        //step events
        this.$el.on(RemoteDataEvent.CREATE, this.onCreatedNewName);
        this.$el.on(ComponentEvent.RESET, this.onReset);

        this.state.step = 0;

        this.$introCopy = $('.intro', this.$el);
        this.$outroCopy = $('.outro', this.$el);
		this.$image = $('.img-wrapper', this.$el);
		
		this.$outroCopy.hide();

        //fade in animation
        this.fadeHideElement(this.$introCopy)
            .fadeHideElement(this.$image)
            .fadeHideElement(this.$step);

        this.timeline = new TimelineLite();
        this.timeline.call(this.fadeInElement, [this.$introCopy], this, "+=0.3");
        this.timeline.call(this.fadeInElement, [this.$image], this, "+=0.5");
        this.timeline.call(this.fadeInElement, [this.$step], this, "+=0.5");
        this.timeline.play();

        return this.update(true);
    }

    update(force = false) {
        if(!_.isEqual(this._internalState, this.state) || force) {
            //update step / subPage
            this.state.subPage = this.state.step == 0
                ? this.stepInput : this.stepOutput;

            if(this._internalState.subPage) this._internalState.subPage.$el.detach();
            this.$step.append(this.state.subPage.$el);

            this.state.subPage.update();

            this._internalState = _.clone(this.state);
            site.instance.updateViewport();
        }

        return this;
    }

    onCreatedNewName(evt, newName) {
		this.stepOutput.state.newName = newName;
		

		this.$introCopy.hide();
		this.$outroCopy.show();

        return this.stepOutput.updateList(newName).then(() => {
            this.state.step = 1;
            this.update();
		});
    }

    onReset(evt) {
        this.stepInput.state.inputString = "";
        this.state.step = 0;
        return this.update();
    }
}

if(!_.isObjectLike(site)) var site = {components:{}};
site.components.Page01 = Page01;
